export const endorsementWallSchema = {
  type: 'endorsement-wall',
  label: 'Endorsement Wall',
  description: 'Approved endorsements from community leaders (custom block)',
  icon: 'Quote',
  isCustom: true,
  defaultContent: {
    heading: 'Endorsements',
    style: {},
  },
  fields: [
    { name: 'heading', label: 'Section Heading', type: 'text' },
  ],
};
